import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=254cf13a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254cf13a"]])

export default __exports__